enum AuthenticationProviderEnum {
  coptor = 'coptor',
  authz = 'authz'
}

export default AuthenticationProviderEnum;
